const ResetAccountModal = ({
  darkMode,
  resetAccountId,
  resetFeeAmount,
  setResetFeeAmount,
  trackResetFees,
  currentPeriod,
  onClose,
  onReset
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-60">
      <div className={`rounded-2xl p-6 w-full max-w-md transition-colors duration-300 ${
        darkMode ? 'bg-gray-950/90 backdrop-blur-2xl border border-white/10' : 'bg-white'
      }`}>
        <h3 className={`text-lg font-bold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
          Reset Account
        </h3>
        
        <div className={`p-3 rounded-lg mb-4 ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
          <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Resetting will start a new trading period. All current trades will be marked as Period {currentPeriod || 1}.
          </p>
        </div>
        
        {trackResetFees && (
          <div className="mb-4">
            <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Reset Fee
            </label>
            <div className="flex items-center gap-2">
              <span className={darkMode ? 'text-gray-400' : 'text-gray-500'}>$</span>
              <input
                type="number"
                value={resetFeeAmount}
                onChange={(e) => setResetFeeAmount(parseFloat(e.target.value) || 0)}
                className="flex-1 input-modern"
              />
            </div>
          </div>
        )}
        
        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className={`px-4 py-2 rounded-lg border transition-[background-color,border-color,box-shadow,color] duration-150 ${
              darkMode
                ? 'bg-white/[0.04] border-white/10 text-gray-300 hover:bg-white/[0.08] hover:border-white/20 hover:text-white'
                : 'bg-white/60 border-gray-200 text-gray-700 hover:bg-white/80 hover:border-gray-300 hover:text-gray-900'
            }`}
          >
            Cancel
          </button>
          <button
            onClick={() => onReset(resetAccountId, resetFeeAmount, 'Manual Reset')}
            className={`px-4 py-2 rounded-lg border transition-[background-color,border-color,box-shadow,color] duration-150 ${
              darkMode
                ? 'bg-yellow-500/25 border-yellow-400/50 text-yellow-50 ring-1 ring-inset ring-yellow-400/25 hover:bg-yellow-500/35 hover:border-yellow-400/70 hover:shadow-[0_0_18px_rgba(234,179,8,0.3)]'
                : 'bg-yellow-100 border-yellow-300 text-yellow-800 hover:bg-yellow-200 hover:border-yellow-400'
            }`}
          >
            Reset Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetAccountModal;
